<template>
  <div class="page-container">

    <el-tabs v-model="activeName">
      <el-tab-pane label="用户账单" name="bill">
        <el-card class="page-content" shadow="never">
          <el-tabs :value="activeTab" @tab-click="handleTabChange">
            <el-tab-pane label="所有" name="all"></el-tab-pane>
            <!-- <el-tab-pane label="资金划转" name="huazhuan"></el-tab-pane> -->
            <el-tab-pane v-for="type in billTypeList" :key="type.value" :label="type.label" :name="type.value" v-if="['2','3','7','8','9','10','11','18','19','20','30','31','32','33','34'
            ,'35','36','37','38','39','41','42','43','44','47','48','49','50','010','011','014','017'].indexOf(type.value) === -1"></el-tab-pane>
          </el-tabs>
          <div class="page-actions" style="position: static;float: left">
            <el-autocomplete placeholder="输入币种" v-model="coinType" :fetch-suggestions="queryCoinType"/>

            <el-input placeholder="请输入账号ID" clearable v-model="uid">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-date-picker
                    type="datetimerange"
                    value-format="timestamp"
                    v-model="timeRange"
                    start-placeholder="起始时间"
                    end-placeholder="终止时间"
            >
            </el-date-picker>
            <el-button @click="handleSearch" type="primary">搜索</el-button>
            <el-button @click="handleSearchClear" type="">重置</el-button>
          </div>
          <div class="preview-opration" style="float: right;;right: 0px; white-space:nowrap">
            <download-excel
                class="export-excel-wrapper"
                :data="this.getDetailsForm()"
                :fields="excelData.json_fields"
                :header="excelData.title"
                name="用户账单.xls"
                :before-generate="beforeGenerate"
            >
              <el-button type="success">导出</el-button>
            </download-excel>
          </div>
          <bill-list @refresh="getList" :billType="activeTab"></bill-list>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="资产分析" name="analysis">
            <balance-analysis/>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import BillList from './components/list';
import BalanceAnalysis from "./components/BalanceAnalysis";
import moment from 'moment';
import api from "@/entries/Account/api";
import {BILL_TYPE} from "@/entries/UserBill/constants";
const TIME_RANGE = [
  new Date(
    moment()
      .subtract(12, 'hour')
      .startOf('day')
      .add(12, 'hour')
      .valueOf()
  ),
  new Date()
];
export default {
  name: 'UserBill',
  data() {
    return {
      uid: undefined,
      coinType: '',
      // timeRange: TIME_RANGE,
       timeRange: [new Date().getTime()-24 * 60 * 60 * 60 * 1000,new Date().getTime()],
      // timeRange: null,
      activeName:'bill',
      excelData:{
        title:"用户账单",
        json_fields:{
          "时间":'businessTime',
          "账号ID":{
            field:'userId',
            callback: value =>{
              return "&nbsp;" + value;
            }
          },
          "币种":'coinType',
          "类型":'businessType',
          "可用变动":'availableAmountChange',
          "可用":'availableAfterChange',
          "冻结变动":'frozenAmountChange',
          "冻结":'frozenAfterChange',
          "备注":'remark'
        }
      }
    };
  },
  components: {
    BillList,
    BalanceAnalysis
  },
  computed: {
    ...mapState('userBill', ['coinTypeList', 'pagination', 'activeTab']),
    ...mapGetters('userBill', ['billTypeList','billList'])
  },
  watch: {
    coinType(val, oldval) {
      if (val != oldval) {
        this.coinType = val;
        // this.getList({ page: 1 });
      }
    }
  },
  methods: {
    ...mapActions('userBill', ['listCoinType', 'listBillType', 'reqBills','reqBillsExcel']),
    ...mapMutations('userBill', ['changeTab']),
    handleSearch() {
      this.getList({ page: 1 });
    },
    handleSearchClear(){
      this.coinType='';
      this.timeRange=null;
      this.uid=undefined;
      this.getList({ page: 1 });
    },
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({ page: 1 });
    },
    getDetailsForm(){
      let excelData= this.billList.map(item => ({
        ...item,
        businessTime:"&nbsp;"+this.formatDate(item.businessTime),
        __type: BILL_TYPE[item.businessType]
      }));
      return excelData;
    },
    getList(data = {}) {
      // if (!this.uid) {
      //   this.$message.error('请输入用户ID');
      //   return;
      // }
      this.reqBills({
        uid: this.uid,
        billType: this.activeTab === 'all' ? '' : this.activeTab,
        coinType: this.coinType,
        from:
          this.timeRange && this.timeRange[0]
            ? this.timeRange[0]
            : undefined,
        to:
          this.timeRange && this.timeRange[1]
            ? this.timeRange[1]
            : undefined,
        ...this.pagination,
        ...data
      });
    },
    queryCoinType(queryString,cb) {
      let restaurants = this.coinTypeList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index]});
      }
      cb(suggest);
    },

    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    exportData(){
      this.reqBillsExcel({
        uid: this.uid,
        billType: this.activeTab === 'all' ? '' : this.activeTab,
        coinType: this.coinType,
        from:
            this.timeRange && this.timeRange[0]
                ? this.timeRange[0]
                : undefined,
        to:
            this.timeRange && this.timeRange[1]
                ? this.timeRange[1]
                : undefined,
        ...this.pagination
      });
    },
    //时间戳转换方法    date:时间戳数字
    formatDate(date) {
      console.log(date)
      var date = new Date(date);
      console.log(date)
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD + " " + hh + mm + ss;
    },
    beforeGenerate(){
      if (this.getDetailsForm().length<1){
        alert("无数据导出")
      }
    }
  },
  created() {
    this.changeTab('all');
    this.listCoinType();
    this.listBillType();
    setTimeout(()=>{
      this.getList({ page: 1 });
      console.log(this.billTypeList)
    },1000 )
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
